import React, { useCallback } from 'react';
import styled from 'styled-components';
import Floater from 'gatsby-theme-core/src/components/floater/float-children';
import CoreButton from 'gatsby-theme-core/src/components/button/index';
import { useModals } from '../../context/modals';

const useButtonOnClick = (onClick, openModalWithIdentifier) => {
  const { identifierIsModal, setModalOpen } = useModals();
  const openModalFunction = useCallback(
    () => setModalOpen(openModalWithIdentifier, true),
    [
      setModalOpen,
      openModalWithIdentifier,
    ],
  );
  return useCallback((...args) => {
    const openModal = identifierIsModal(openModalWithIdentifier);
    if (openModal) {
      openModalFunction(...args);
    }
    if (onClick) {
       onClick(...args);
     }
  }, [
    openModalFunction,
    identifierIsModal,
    openModalWithIdentifier,
    onClick,
  ]);
};

const Button = ({
  className,
  id,
  nth = 0,
  variant,
  link,
  text,
  size,
  width,
  onClick = null,
  isPrimaryCta = false,
  openModalWithIdentifier = null,
  eventActionResult = undefined, // can be set from shadow
}) => {
  const onClickFn = useButtonOnClick(onClick, openModalWithIdentifier);
  return (
    <Floater useFloater={isPrimaryCta}>
      <CoreButton
        className={className}
        key={id}
        to={link}
        onClick={onClickFn}
        primary={variant === 'primary'}
        secondary={variant === 'secondary'}
        dark={variant === 'dark'}
        outline={variant === 'outline'}
        outlineWhite={variant === 'outlineWhite'}
        outlineDark={variant === 'outlineDark'}
        link={variant === 'link'}
        standout={variant === 'standout'}
        large={size === 'large'}
        wide={width === 'wide'}
        nth={nth}
        eventActionResult={openModalWithIdentifier ? 'popup' : eventActionResult}
      >
        {text}
      </CoreButton>
    </Floater>
  );
};

export default styled(Button)``;
